module.exports = __webpack_public_path__ + "img/mobile.91031088.png";